import { Ref } from "react";
import { useTranslation } from "react-i18next";
import LocationOptionTemplate from "./LocationOptionTemplate";
import type { PanelTreeNode } from "./PanelTemplate";

interface LocationListProps {
    activeNodeKey: string | null;
    activeNodeRef: Ref<HTMLDivElement>;
    company: PanelTreeNode;
    isLocationActive: (companyId: string, locationId: string) => boolean;
    onLocationSelect: (companyId: string, locationId: string) => void;
}

const LocationList = (props: LocationListProps) => {
    const {
        activeNodeKey,
        activeNodeRef,
        company,
        isLocationActive,
        onLocationSelect,
    } = props;

    const { t } = useTranslation("common");

    return (
        <>
            <div className="px-2.5 pb-1.5 pt-2 text-xxs leading-2.75 font-semibold uppercase tracking-wide text-text-300">
                {t("common:switchLocation")}
            </div>
            {company.children?.map((location) => (
                <LocationOptionTemplate
                    key={location.id}
                    location={location}
                    isSelected={isLocationActive(company.id, location.id)}
                    ref={
                        activeNodeKey ===
                        `location-${company.id}-${location.id}`
                            ? activeNodeRef
                            : null
                    }
                    onSelect={() => onLocationSelect(company.id, location.id)}
                />
            ))}
        </>
    );
};

export default LocationList;
